const SIZE_FIT_GROUP_CLASS = 'variant-size-fit-group';

/**
 * @param {Element} popup
 * @returns {HTMLElement | null}
 */
function findPickerForPopup(popup) {
  const details = popup.closest('.product-details');
  if (!details) return null;

  let node = popup.previousElementSibling;
  while (node) {
    if (node.matches('variant-picker')) return node;
    if (node.classList.contains(SIZE_FIT_GROUP_CLASS)) {
      return node.querySelector('variant-picker');
    }
    node = node.previousElementSibling;
  }

  return details.querySelector('variant-picker');
}

/**
 * @param {Element} group
 */
function alignSizeFitLink(group) {
  const picker = group.querySelector('variant-picker');
  const popup = group.querySelector('.popup-link--size-fit');
  const legend = picker?.querySelector('fieldset[data-option-name="size"] legend');

  if (!picker || !popup || !legend) return;

  const groupTop = group.getBoundingClientRect().top;
  const legendTop = legend.getBoundingClientRect().top;
  popup.style.setProperty('--size-fit-top', `${legendTop - groupTop}px`);
}

/**
 * @param {Element} popup
 */
function setupPopup(popup) {
  const picker = findPickerForPopup(popup);
  if (!picker) return;

  const sizeFieldset = picker.querySelector('fieldset[data-option-name="size"]');
  if (!sizeFieldset) return;

  let group = popup.parentElement;
  if (!group?.classList.contains(SIZE_FIT_GROUP_CLASS)) {
    const parent = picker.parentElement;
    if (!parent || popup.parentElement !== parent) return;

    group = document.createElement('div');
    group.className = SIZE_FIT_GROUP_CLASS;
    parent.insertBefore(group, picker);
    group.append(picker, popup);
  }

  alignSizeFitLink(group);
}

function setupSizeFitLayout() {
  document.querySelectorAll('.product-details .popup-link--size-fit').forEach(setupPopup);
}

let resizeTimer;
function onResize() {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(() => {
    document.querySelectorAll(`.${SIZE_FIT_GROUP_CLASS}`).forEach(alignSizeFitLink);
  }, 100);
}

function init() {
  setupSizeFitLayout();
  requestAnimationFrame(() => {
    setupSizeFitLayout();
    document.querySelectorAll(`.${SIZE_FIT_GROUP_CLASS}`).forEach(alignSizeFitLink);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}

document.addEventListener('shopify:section:load', init);
document.addEventListener('variant:update', () => {
  requestAnimationFrame(() => {
    setupSizeFitLayout();
    document.querySelectorAll(`.${SIZE_FIT_GROUP_CLASS}`).forEach(alignSizeFitLink);
  });
});
window.addEventListener('resize', onResize);
